/* eslint-disable no-console */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { useState } from 'react';
import NumberFormat from 'react-number-format';
import apiBackendInstance from '../../../utils/axios';

import Urls from '../../../utils/urls';
import CustomLoader from '../../common/loader';
import { subscriptionItem } from './subscription';

interface props{
    data: subscriptionItem,
    setShowModal:(x:boolean)=>void
}
interface addOnType{
  addon_code: string,
  name: string,
  total_quantity: number,
  available_quantity: number,
  price: number,
  description: string,
}

interface baseType{
plan_code: string,
name: string,
total_quantity: number,
available_quantity: number,
price: number,
description: string,
}
const UpdateSubscription = ({ data, setShowModal }:props) => {
  const tData = JSON.stringify(data.subscription_details.addons);
  const tbaseData = JSON.stringify(data.subscription_details.plan);
  const [addOnData, setAddOnData] = useState<addOnType[]>(JSON.parse(tData));
  const [update, setUpdate] = useState(true);
  const [message, setMesage] = useState('');
  const [showMsg, setShowMsg] = useState(false);
  const [baseData, setBaseData] = useState<baseType>(JSON.parse(tbaseData));
  const [showBtn, setBtn] = useState('1');
  const [showLoader, setShowLoader] = useState(false);

  const updateSubscription = () => {
    localStorage.setItem('market_place_source', 'subscriptionUpdate');
    const continueBtn:any = document.getElementById('continueButton');
    setBtn('2');
    setShowLoader(true);
    let allowRequest = false;
    const sendArr = [];
    const planObj = { plan_code: baseData.plan_code };
    for (let i = 0; i < addOnData.length; i += 1) {
      const originalQuantity = data.subscription_details.addons[i].total_quantity;
      if (addOnData[i].total_quantity !== originalQuantity) {
        const obj = { addon_code: addOnData[i].addon_code, quantity: addOnData[i].total_quantity - originalQuantity };
        sendArr.push(obj);
        allowRequest = true;
      }
    }
    if (!allowRequest) {
      showMessage('Please do updation in subscription before submitting.');
      setBtn('1');
      hideLoader();
    } else {
      const sendData = {
        subscriptionId: data.subscription_details.subscriptionId,
        plan: planObj,
        addons: sendArr,
        redirection_url: `${window.location.origin}/app/success?linkname=Go%20to%20Settings&linkvalue=/app/Account`,
      };
      apiBackendInstance.post(Urls.getSubcriptionUpdateUrl(), {
        ...sendData,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (response && response.data) {
            showMessage(response.data.data.message);
            if (continueBtn) {
              const redirectUrl = response.data.data.redirection_url ? response.data.data.redirection_url : '';
              if (response.data.data.message === 'Redirecting to payment page.') {
                continueBtn.href = redirectUrl;
              } else {
                continueBtn.href = window.location.href;
              }
              continueBtn.style.display = 'block';
            }
          }
          hideLoader();
        }).catch((err) => {
          console.error(err);
          const errMsg = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Updation failed.';
          showMessage(`Error: ${errMsg}`);
          setBtn('1');
          hideLoader();
        });
    }
  };

  const incrementQuantity = (type:string, idx:number) => {
    hideMessage();
    if (type === 'base') {
      baseData.available_quantity += 1;
      baseData.total_quantity += 1;
      setBaseData(baseData);
    } else {
      addOnData[idx].available_quantity += 1;
      addOnData[idx].total_quantity += 1;
      setAddOnData(addOnData);
    }

    setUpdate(!update);
  };
  const decrementQuantity = (type:string, idx:number) => {
    if (type === 'base') {
      if (baseData.available_quantity > 0) {
        baseData.available_quantity -= 1;
        baseData.total_quantity -= 1;
        setBaseData(baseData);
        setUpdate(!update);
      } else {
        showMessage('Available count is 0. Cannot perform operation.');
      }
    } else if (addOnData[idx].available_quantity > 0) {
      addOnData[idx].available_quantity -= 1;
      addOnData[idx].total_quantity -= 1;
      setAddOnData(addOnData);
      setUpdate(!update);
    } else {
      showMessage('Available count is 0. Cannot perform operation.');
    }
  };
  const showMessage = (msg: string) => {
    setMesage(msg);
    setShowMsg(true);
  };
  const hideMessage = () => {
    setShowMsg(false);
  };
  const hideLoader = () => {
    setShowLoader(false);
  };

  return (
        <div id="subscribeModal" className="workModal text-black" style={{ display: 'block' }}>
        <div className="workModalContent" style={{ width: '750px', fontSize: '12px' }}>
          <CustomLoader showLoader={showLoader} />
          <span onClick={() => { setShowModal(false); }} className="closeWork">&times;</span>
            <h5 className="modalHeading mb-4 text-center" id="modalHeadingDelete">
             Update Subscription
            </h5>
            <div className="row mt-4">
                <div className="col-3">
                    <b className="mx-4">Services</b>
                </div>
                <div className="col-2">
                    <b>Monthly Cost</b>
                </div>
                <div className="col-3">
                    <b>Total Subscribed</b>
                </div>
                <div className="col-1">
                    <b>Available</b>
                </div>
                <div className="col-3">
                    <b className="px-3">Update Subscription</b>
                </div>
            </div>
            <div className="row">
                <div className="px-4 col-12">
                    <hr />
                </div>
            </div>
            <ul className=" flex-column">
            { addOnData.map((d, idx) => (
                <>
                    <li key={`lii78tem_${idx.toString()}`} className="mt-1">
                        <div className="row">
                            <div className="col-3">
                                <span className="modalFields">{d.name}</span>
                            </div>
                            <div className="col-2">
                              <span className="mx-1 modalFields">
                                <NumberFormat value={d.price * d.total_quantity} displayType="text" decimalScale={2} thousandSeparator prefix="$ " />
                              </span>
                            </div>
                            <div className="col-3">
                              <input className="col-3 text-center p-1" style={{ fontSize: '12px' }} type="text" disabled value={d.total_quantity} />
                            </div>
                            <div className="col-1">
                              <input className="col-10 text-center p-1" style={{ fontSize: '12px' }} type="text" disabled value={d.available_quantity} />
                            </div>
                            <div className="col-2 mx-2 ms-4 text-muted text-center" style={{ fontSize: '17px' }}>
                                <span className="mx-2 btnNode text-danger" onClick={() => { decrementQuantity('addon', idx); }}><i className="fa fa-minus-circle" /></span>
                                <span className="mx-1 btnNode text-success" onClick={() => { incrementQuantity('addon', idx); }}><i className="fa fa-plus-circle" /></span>
                            </div>
                        </div>
                    </li>
                    <div className="row mb-2">
                    <div className="col-12 ps-0">
                        <hr />
                    </div>
                    </div>
                </>
            ))}
            </ul>
            { showMsg && (
            <p id="responseMsg" className="mt-3 text-muted text-center">
             {message}
            </p>
            )}
            {showBtn === '1' && (
                <div className="text-center">
                    <button type="button" style={{ margin: 'auto' }} id="deleteNetworkBtn" className="fs-6 btn px-3 comingSoon" onClick={() => { updateSubscription(); }}>Update</button>
                </div>
            )}
            <a
                href="#"
                id="continueButton"
                className="btn comingSoon col-2"
                style={{
                  display: 'none', margin: 'auto', textDecoration: 'none', fontSize: '12px',
                }}
            >
                Continue
            </a>

        </div>
        </div>
  );
};
export default UpdateSubscription;